import { request, serviceUrl } from "@/utils/request";

// 获取误告警屏蔽策略  pageSize pageCurrent
export function getAlarmMissList(
  pageSize = null,
  pageCurrent = null,
  gatewaySn = null,
  spaceId = null,
  deviceId = null,
  pointId = null
) {
  return request({
    url: serviceUrl.deviceService + "/alarm/mis/list",
    params: {
      pageSize,
      pageCurrent,
      gatewaySn,
      spaceId,
      deviceId,
      pointId,
    },
  });
}

// 批量保存误告警屏蔽策略
export function saveOrUpdate(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/mis/saveOrUpdate',
    data: params
  })
}

// 删除误告警屏蔽策略
export function deleteById(id) {
  return request({
    method: 'DELETE',
    url: serviceUrl.deviceService + '/alarm/mis/deleteById',
    params: id
  })
}
// 根据id获取误告警屏蔽策略
export function getById(id) {
  return request({
    url: serviceUrl.deviceService + '/alarm/mis/getById',
    params: id
  })
}

// 启用/停用告警屏蔽策略
export function shieldSwitch(id, isEnable) {
  return request({
    url: serviceUrl.deviceService + '/alarm/mis/shieldSwitch',
    params: {id, isEnable}
  })
}
